<app-header></app-header>

<div class="row h100 exhibitor-backoffice">
  <div class="col-12 col-lg-2 h100 exhibitor-backoffice__left">
    <app-menu-exhibitor [active]="'exhibitors'"></app-menu-exhibitor>
  </div>
  <div class="col-12 col-lg-10 exhibitor-backoffice__right">

    <app-menu-exhibitor-sub-menu [active]="'products'" [exhibitor]="projection"></app-menu-exhibitor-sub-menu>

    <div class="exhibitor-backoffice__content" *ngIf="loader.count === 0">
      <div class="filter-button-container">
        <div class="form-group form-group--filter">
          <input type="text" class="form-control" [(ngModel)]="filter" name="filter" placeholder="{{ 'COMMON.SEARCH' | translate }}" #ffilter="ngModel">
        </div>
        <div class="mb-5">
          <button type="button" (click)="goToCreate(buttonLink)" class="btn btn--primary">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_PRODUCTS.CREATE_PRODUCT' | translate }}</button>
          <button type="button" (click)="translateProducts()" [disabled]="disabled" class="btn btn--primary float-start mr-md-3 mb-6" [style.background-color]="catalogueService.getProperty('mainColor')" [style.color]="catalogueService.getProperty('languageColor')">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_PRODUCTS.IA_TRANSLATION' | translate }}</button>
        </div>
      </div>
      <div class="table__wrapper">
        <table class="table">
          <thead>
            <tr>
              <th scope="col" style="width: 70%">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_PRODUCTS.COL_NAME' | translate }}</th>
              <th scope="col" style="width: 10%">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_PRODUCTS.COL_VISIBLE' | translate }}</th>
              <th scope="col" style="width: 10%">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_PRODUCTS.COL_NOVELTY' | translate }}</th>
              <th scope="col" style="width: 10%; text-align: right">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_PRODUCTS.COL_ACTIONS' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let product of filterElements() | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize; let i = index" (click)="goTo(product)">
              <td>{{ utilsService._api(product.translations, 'name') }}</td>
              <td>
                <div class="form-check form-switch" (click)="togglePublished(product, $event)">
                  <input class="form-check-input" type="checkbox" [(ngModel)]="product['published']" [checked]="product['published']" role="switch" id="published{{ i }}">
                </div>
              </td>
              <td>
                <div class="form-check form-switch" (click)="toggleNovelty(product, $event)">
                  <input class="form-check-input" type="checkbox" [(ngModel)]="product['novelty']" [checked]="product['novelty']" role="switch" id="novelty{{ i }}">
                </div>
              </td>
              <td class="col-actions">
                <svg width="24" height="24" title="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_PRODUCTS.ACTION_EDIT' | translate }}" (click)="editProduct(product, $event)" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.99854 21.0013H6.74854L17.8085 9.94128L14.0585 6.19128L2.99854 17.2513V21.0013ZM4.99854 18.0813L14.0585 9.02128L14.9785 9.94128L5.91854 19.0013H4.99854V18.0813Z" fill="#5E5064"/>
                  <path d="M18.3685 3.29128C17.9785 2.90128 17.3485 2.90128 16.9585 3.29128L15.1285 5.12128L18.8785 8.87128L20.7085 7.04128C21.0985 6.65128 21.0985 6.02128 20.7085 5.63128L18.3685 3.29128Z" fill="#5E5064"/>
                </svg>

                <svg width="24" height="24" (click)="removeProductBtn(product, $event)" title="{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_PRODUCTS.ACTION_REMOVE' | translate }}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z" fill="#5E5064"/>
                </svg>
              </td>
            </tr>
            <tr *ngIf="filterElements().length < 1">
              <td colspan="5">{{ 'EXHIBITOR_BACKOFFICE_EXHIBITOR_PRODUCTS.NO_PRODUCTS' | translate }}</td>
            </tr>
          </tbody>
        </table>
        <ngb-pagination class="d-flex justify-content-end" [(page)]="page" [pageSize]="pageSize"
                        [collectionSize]="filterElements().length" [maxSize]="10"></ngb-pagination>
      </div>
      <div *ngIf="alertMessage" class="text-danger">{{alertMessage | translate}}</div>
    </div>

  </div>
</div>
<app-footer></app-footer>
